export class SavedSearchConfig {

    public searchId: number;
    public searchName: string;
    public searchNameOrig: string;

}


